import DateHelper from "~/helpers/DateHelper";
import ObjectHelper from "~/helpers/ObjectHelper";

export function modelContainsIncludes(model, includes) {
    if (!model.hasOwnProperty('includes')) {
        return false;
    }

    let containsAllIncludes = true;

    includes.forEach(function (include) {
        if (!model.includes.includes(include) || !containsAllIncludes) {
            containsAllIncludes = false;
        }
    })

    return containsAllIncludes;
}

export function expired(model) {
    if (model.hasOwnProperty('cache') && model.cache && model.cache.hasOwnProperty('expires_at')) {
        return model.cache.expires_at > DateHelper.unixTimestamp();
    }

    return true;
}

export async function reduce(model, dispatch, bindings, ignore = []) {
    for (let field in bindings) {
        if (bindings.hasOwnProperty(field)) {
            let dispatchName = bindings[field];
            if (ObjectHelper.isObject(model) && model.hasOwnProperty(field) && !ignore.includes(field)) {
                if (Array.isArray(model[field])) {
                    for (let i = 0; i < model[field].length; i++) {
                        await dispatch(dispatchName, model[field][i], { root: true });
                    }
                } else {
                    await dispatch(dispatchName, model[field], {root: true});
                }

                delete model[field];
            }
        }
    }

    return model;
}
